import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(special_header)/contact/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/vercel/path0/src/components/Form/index.tsx");
